import PackageJson from "../../package.json";

export const name = PackageJson.name;
export const version = PackageJson.version;

// Production Server
let _url = "https://api.panel.snappcarfix.com";
// _url = "http://172.10.10.71:8000"
if (window.location.host === "dev.panel.snappcarfix.com") {
    _url = "https://dev.api.panel.snappcarfix.com";
}
export const baseURL = _url;
export const test = false;
// Dev Server
// export const baseURL = "http://127.0.0.1:8000";
// export const baseURL = "http://192.168.43.173:8000";
// export const baseURL = "https://api.staging.t2bon.com";
